<template lang="pug">
  div.stu-footer(:style="isJF ? 'height:40px;' : ''")
    div(:style="isJF ? 'height:40px;' : ''")
      div.fl.text-ct.stu-footer-info
        span.fl.f12.grey9
          | {{ copyright + cfName + $t('footer.copyright') }}
          i(v-if="!isJF")
</template>

<script>
export default {
  name: 'Footer',
  data() {
    const { cfName } = window.ConfigNew.header
    const { copyright, icp, police, icon } = window.ConfigNew.footer
    const djgId = localStorage.getItem('djg-id')
    return {
      cfName,
      copyright,
      icp,
      police,
      icon,
      djgId,
      isJF: this.$store.state.isJF
    }
  },
  mounted() {
    if (!this.isJF) {
      window.renderFooter()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Stu/footer.vue